module.exports = __webpack_public_path__ + "static/img/home_backgroud_right.59f0e34f.png";